import { render, staticRenderFns } from "./SurfaceZonificationItem.vue?vue&type=template&id=a63f26f8&scoped=true"
import script from "./SurfaceZonificationItem.vue?vue&type=script&lang=ts"
export * from "./SurfaceZonificationItem.vue?vue&type=script&lang=ts"
import style0 from "./SurfaceZonificationItem.vue?vue&type=style&index=0&id=a63f26f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63f26f8",
  null
  
)

export default component.exports